import cn from "classnames"
import { forwardRef } from "react"

import { Typography } from "antd"

import styles from "./Text.module.scss"

import type { TextProps } from "antd/lib/typography/Text"

export const Text = forwardRef<HTMLSpanElement, TextProps>(
  ({ ellipsis, ...props }, ref) => {
    if (ellipsis && typeof ellipsis === "boolean")
      return (
        <span className={cn(styles.ellipsis, props.className)} ref={ref}>
          <Typography.Text {...props} />
        </span>
      )

    return <Typography.Text ref={ref} ellipsis={ellipsis} {...props} />
  }
)

Text.displayName = "Text"
